import React from 'react'
// import { CSSTransitionGroup } from 'react-transition-group';
import { __, sprintf } from 'StylistParent/i18n'

import Label from '../control-label'
import SelectorItem from './selector-item'
import SelectorEdit from './selector-edit'
import Dashicon from 'Components/dashicon'
import { keycodes } from 'StylistParent/utils'
// import Tooltip from '../../../tooltip'

/* Import CSS */
import './index.scss'

const { ESCAPE, ENTER } = keycodes;

class CSSSelector extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			selectorParts: [],
			currentPseudoClass: 'none',
			selectorEditingState: false,
			pseudoClass: {
				none: 'Default State',
				hover: 'Hover',
				active: 'Pressed',
				focus: 'Focused',
			},
			message: false,
		}

		// this.onPseudoClassChange = this.onPseudoClassChange.bind(this);

		// this.onCssSelectorInputChange = this.onCssSelectorInputChange.bind(this)
	}

	updateSelectorLabel = () => {
		const { selectedEl, cssSelectorFull, cssSelectorCustom } = this.props;

		if ( selectedEl ) {
			// if ( ! cssSelectorCustom ) { return }
			const selectorParts = cssSelectorCustom.split( ' ' )

			this.setState( ( state ) => ( {
				selectorParts: selectorParts,
			} ) );
		}
	}

	componentWillMount = () => {
		this.updateSelectorLabel()
	}

	onPseudoClassChange = ( event ) => {
		/* let { cssSelectorFull, cssSelectorCustom  } = this.props;

		if ( cssSelectorCustom.includes(':') ) {
			const regex = new RegExp("(:hover|:pressed|:active|:focused)","g");

			if ( event.target.value !== 'none' ) {
				cssSelectorCustom = cssSelectorCustom.replace( regex, ':' + event.target.value )
			} else {
				cssSelectorCustom = cssSelectorCustom.replace( regex, '' )
			}

			this.onCssSelectorChange( cssSelectorCustom )
		} else {
			this.onCssSelectorChange( cssSelectorCustom + ':' + event.target.value )
		} */

		this.setState( { currentPseudoClass: event.target.value } )
		this.props.onPseudoClassChange( event.target.value )
	}

	onCssSelectorChange = ( newSelector ) => {
		this.props.onCssSelectorChange( newSelector )
	}

	onSelectorEditingState = () => {
		this.setState( { selectorEditingState: ! this.state.selectorEditingState } );
	}

	componentDidUpdate = ( prevProps, prevState ) => {
		// Selector changed.
		if ( this.props.cssSelectorCustom !== prevProps.cssSelectorCustom ) {
			this.updateSelectorLabel()

			if ( this.state.selectorEditingState ) {
				this.selectorInput.value = this.props.cssSelectorCustom
			}
		}

		if ( this.state.selectorEditingState ) {
			// Set focus inside selector input field.
			this.selectorInput.focus();

			// Shift cursor to the very end of input text.
			if ( this.selectorInput.selectionStart === 0 ) {
				this.selectorInput.setSelectionRange( 1000, 1001 );
			}
		}
	}

	onCssSelectorInputChange = ( event ) => {
		const newSelector = event.target.value
		// @todo: add Try{} for the statement below as it's often throw the error.
		let matchingEls = []
		try {
			matchingEls = window.Stylist.iBody.querySelectorAll( newSelector )
		} catch ( error ) {
			console.log( "error:" ); console.log( error );
		}

		if ( 0 === matchingEls.length ) {
			this.setState( { message: __( "No element on the page matching this selector!" ) } );
			// @todo: error – can't find elements on the page
		} else {
			let messageMatching = __( ' elements on the page match this selector' )

			if ( 1 === matchingEls.length ) {
				messageMatching = __( ' element on the page match this selector' )
			}
			// Update message.
			this.setState( { message: matchingEls.length + messageMatching } )
			this.props.onCssSelectorChange( newSelector )
		}
	}

	render() {
		// const { values, value, cssSelectorFull } = this.props
		const selectorItems = this.state.selectorParts
		const pseudoClasses = this.state.pseudoClass
		const cssSelectorCustom = this.props.cssSelectorCustom
		const inspectorActive = this.props.inspectorActive

		return (
			<div id="cssselector-control" className="stlst-selector">
				{ ! inspectorActive && cssSelectorCustom &&
				<SelectorEdit
					onSelectorEditingState={this.onSelectorEditingState} /> }

				{ ! inspectorActive && cssSelectorCustom && ! this.state.selectorEditingState && <div className="stlst-control-main stlst-control-main--selector">
					{ selectorItems.map( function( item, idx ) {
						const lastItem = selectorItems.length - 1 === idx ? true : false
						return <SelectorItem key={ idx } lastItem={lastItem}>{ item }</SelectorItem>;
					} ) }
					{/* {this.state.selectorParts} */}
				</div> }

				{ 1 === 2 && ! inspectorActive && cssSelectorCustom && ! this.state.selectorEditingState && <select
					className="stlst-selector--pseudo-class"
					onChange={this.onPseudoClassChange}
					value={this.state.currentPseudoClass} >
					{ Object.keys( pseudoClasses ).map( ( key, index ) => (
						<option
							value={key}
							key={index} >{ pseudoClasses[ key ] }</option>
					) ) }
				</select> }

				{ this.state.selectorEditingState &&
					<div className="stlst-selector--editing">

						{ ! inspectorActive && cssSelectorCustom && this.state.selectorEditingState &&
						<input type="text"
							className="stlst-selector--input"
							spellCheck="false"
							ref={ ( input ) => {
								this.selectorInput = input;
							} }
							defaultValue={cssSelectorCustom}
							onChange={this.onCssSelectorInputChange}
							onKeyDown={ ( event ) => {
								if ( event.keyCode === ESCAPE || event.keyCode === ENTER ) {
									event.stopPropagation();
									this.onSelectorEditingState();
								}
							} } /> }
						{ this.state.message &&
							<div className="stlst-selector--dropdown">
								{ this.state.message && <div className="stlst-selector--dropdown-message"><Dashicon icon="info-outline" /> { this.state.message }</div> }
							</div> }

					</div> }

				{ inspectorActive && <div className="stlst-selector--placeholder"><Dashicon icon="info-outline" /> <h4>{ __( "Click on any element to style it" ) }</h4></div> }
				{ ! inspectorActive && ! cssSelectorCustom && <div className="stlst-selector--placeholder"><Dashicon icon="flag" /> <h4>{ __( "No element selected for styling" ) }</h4></div> }

			</div>
		)
	}
}

export default CSSSelector;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/css-selector/index.jsx